import axios from 'axios';
import paths from './../../../settings.json';

const PATH = window.location.protocol + '//' + window.location.host + paths.path_url;

const axiosRequest = (path, data, functionIn) => {
    axios.post(PATH+path, 
        data
    ).then(function (response) {
        // console.log(window);
        // console.log(response.data);
        functionIn(response.data);
    }).catch(function (error) {
        console.log(error);
    });
};

export default axiosRequest;